import React from 'react';
import { Paper, Typography, Slider, Stack, Box, Button } from '@mui/material';
import { IBieMixerDriver } from './bie.models';
import { formatMoney } from './BieValue';

type Props = {
  drivers?: IBieMixerDriver[];
  disabled?: boolean;
  onChangeCommitted: (drivercode: string, value: number) => void;
};

type State = {
  values: Record<string, number>;
};

class DriverMixer extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { values: {} };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.drivers !== this.props.drivers) {
      const values: Record<string, number> = {};
      (this.props.drivers || []).forEach(d => {
        values[d.drivercode] = Number(d.currentvalue || 0);
      });
      this.setState({ values });
    }
  }

  handleChange = (drivercode: string, value: number | number[]) => {
    this.setState({ values: { ...this.state.values, [drivercode]: Number(value) } });
  };

  render() {
    const { drivers = [], disabled, onChangeCommitted } = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Driver Mixer</Typography>
          <Typography variant="caption" color="text.secondary">{drivers.length} adjustable drivers</Typography>
        </Box>

        <Stack spacing={2.5} sx={{ mt: 2 }}>
          {drivers.map(d => {
            const min = Number(d.minvalue ?? 0);
            const max = Number(d.maxvalue ?? Math.max(Number(d.currentvalue || 0) * 2, 100));
            const val = this.state.values[d.drivercode] ?? Number(d.currentvalue || 0);
            return (
              <Box key={d.drivercode}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <Typography variant="body2" fontWeight={600}>{d.driver}</Typography>
                  <Typography variant="body2" color="text.secondary">{formatMoney(val)} {d.unitcode || ''}</Typography>
                </Box>
                <Slider
                  disabled={disabled}
                  value={val}
                  min={min}
                  max={max}
                  step={(max - min) / 100 || 1}
                  onChange={(_, v) => this.handleChange(d.drivercode, v)}
                  onChangeCommitted={(_, v) => onChangeCommitted(d.drivercode, Number(v))}
                />
              </Box>
            );
          })}

          {drivers.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No adjustable drivers configured.
            </Typography>
          )}
        </Stack>
      </Paper>
    );
  }
}

export default DriverMixer;
